import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ImportSizeDataService } from '../../services/import-size-data.service';
import { Brand, SizeType } from '../../models/import-size-data.models';
import { forkJoin } from 'rxjs';
import { createStructSDK } from '@structdk/extension-sdk';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-import-size-guides',
  imports: [FormsModule, NgSelectModule],
  templateUrl: './import-size-guides.component.html',
  styleUrl: './import-size-guides.component.css',
})
export class ImportSizeGuidesComponent implements OnInit {
  constructor(private importSizeDataService: ImportSizeDataService, private cdr: ChangeDetectorRef) {
   
  }

  sizeTypes: SizeType[] = [];
  selectedSizeType: string = "";
  brands: Brand[] = [];
  selectedBrand: string = "";
  selectedFile: File | null = null;
  importdata: any = null
  importvalid: boolean = false;
  working: boolean = false;

  ngOnInit(): void {
    forkJoin({
      brands: this.importSizeDataService.getBrands(),
      sizeTypes: this.importSizeDataService.getSizeTypes(),
    }).subscribe({
      next: (data) => {
        this.brands = data.brands;
        this.sizeTypes = data.sizeTypes;
        
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.cdr.detectChanges();
      }
    });
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    } else {
      this.selectedFile = null;
    }
  }

  reset(): void {
    this.selectedFile = null;
    
    this.selectedBrand = "";
    this.selectedSizeType = "";

    this.importdata = null;
    this.importvalid = false;
  }

  get isValid(): boolean {
      return Boolean(this.selectedFile !== null && this.selectedBrand && this.selectedSizeType);
  }

  validate(): void {
    this.working = true;
    var data = new FormData()

    data.append("File", this.selectedFile!);
    data.append("BrandUid", this.selectedBrand);
    data.append("SizeTypeUid", this.selectedSizeType);

    this.importSizeDataService.validateSizeImport(data).subscribe({
      next: (response) => {
        this.importdata = response;
        console.log(this.importdata);
        if (this.importdata.InvalidHeaders.length > 0) {
            this.importvalid = false;
        }
        else {
            this.importvalid = true;
        }

        this.working = false;

        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('getSizeGroups failed', error);
        
        this.working = false;
        this.cdr.detectChanges();
      }
    });
}

commit(): void {
    const struct = createStructSDK();

    this.working = true;
          
    var data = new FormData()

    data.append("File", this.selectedFile!);
    data.append("BrandUid", this.selectedBrand);
    data.append("SizeTypeUid", this.selectedSizeType);

    this.importSizeDataService.startSizeImport(data).subscribe({
      next: (response) => {

        this.reset();

        struct.actions.showSnackbarMessage({
          message: 'Uploaded successfully!',
          placement: 'top', // 'top' | 'bottom'
          isError: false,
          durationMs: 3000,    // optional
        });
        
        this.working = false;

        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('getSizeGroups failed', error);
          const message =
          error?.error?.message ||
          error?.statusText ||
          'Something went wrong';
        
        struct.actions.showSnackbarMessage({
          message: message,
          placement: 'top', // 'top' | 'bottom'
          isError: true,
          durationMs: 3000,    // optional
        });

        this.working = false;
        this.cdr.detectChanges();
      }
    });
  }



}
